var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap inline-flex pa-0 ma-0 my-auto"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.employed && _vm.employed.fullName)?_c('span',{staticClass:"title-class"},[_vm._v(" "+_vm._s(_vm.capitalizeText(_vm.employed.fullName))+" ("+_vm._s(_vm.employed.file || "No File")+") ")]):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }